<div class="app-content-container">
  <div class="flex flex-col justify-center items-center h-full">
    <!-- Logo Box -->
    <div class="flex flex-col h-1/5 w-4/5 pb-3 place-content-center">
      <a class="h-full w-full flex flex-col justify-center items-center" target="_blank" [href]="config.logoLink" rel="noopener">
        <img class="h-[2rem]" [src]="logoUrl" alt="LOGO" />
      </a>
    </div>

    <div class="wrapper flex flex-col w-3/5 overflow-hidden items-center h-4/5 max-w-screen-sm">
      <div class="flex flex-col w-full h-full">
        <div class="flex flex-col h-full mb-2">
          <form class="registration-form h-full" [formGroup]="signUpFormGroup" (ngSubmit)="signUpBtnClick()">
            <div class="h-8 mb-2">
              <h2 class="font-bold text-xl text-center" i18n>Sign up</h2>
            </div>

            <!-- First Name -->
            <div class="overflow-y-scroll h-[calc(100%-2.5rem)]">
              <div class="w-full">
                <span class="field-label"><ng-container i18n>First name</ng-container><sup>*</sup></span>
                <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                  <input matInput type="text" placeholder="First Name" formControlName="firstName" tabindex="1" />
                  <mat-error *ngIf="signUpFormGroup.controls['firstName'].errors?.['required']" i18n>First name is required</mat-error>
                </mat-form-field>
              </div>

              <!-- Last Name -->
              <div class="w-full">
                <span class="field-label"><ng-container i18n>Last name</ng-container><sup>*</sup></span>
                <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                  <input matInput type="text" placeholder="Last Name" formControlName="lastName" tabindex="2" />
                  <mat-error *ngIf="signUpFormGroup.controls['lastName'].errors?.['required']" i18n>Last name is required</mat-error>
                </mat-form-field>
              </div>

              <!-- Email address -->
              <div class="w-full">
                <span class="field-label"><ng-container i18n>E-mail address</ng-container><sup>*</sup></span>
                <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                  <input matInput type="text" placeholder="E-mail address" formControlName="email" tabindex="3" />
                  <mat-error *ngIf="signUpFormGroup.controls['email'].errors?.['required']" i18n> Email is required </mat-error>
                  <mat-error *ngIf="signUpFormGroup.controls['email'].hasError('email') || signUpFormGroup.controls['email'].hasError('invalidEmail')" i18n>Invalid email address</mat-error>
                </mat-form-field>
              </div>

              <div class="w-full">
                <span class="field-label" i18n>Confirm e-mail address<sup>*</sup></span>
                <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                  <input matInput type="text" placeholder="Confirm e-mail address" formControlName="confirmEmail" tabindex="3" />
                  <mat-error
                    class="text-[13px]"
                    *ngIf="signUpFormGroup.controls['confirmEmail'].hasError('mismatchedPasswords') && !signUpFormGroup.controls['confirmEmail'].hasError('required')"
                    i18n
                  >
                    E-mail addresses are not same
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Password -->
              <div class="w-full">
                <span class="field-label"><ng-container i18n>Password</ng-container><sup>*</sup></span>
                <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                  <input matInput [type]="passwordInputType" placeholder="Password" formControlName="password" data-test-id="sign-up-field-password" tabindex="4" />
                  <mat-icon class="cursor-pointer" matSuffix (click)="toggleVisibility()">{{ passwordVisible ? 'visibility' : 'visibility_off' }} </mat-icon>
                  <mat-error *ngIf="signUpFormGroup.controls['password'].errors?.['required']" i18n>Password is required</mat-error>
                  <mat-error *ngIf="signUpFormGroup.controls['password'].hasError('passwordStrength')" i18n>
                    Password should have at least 8 characters, a special character, a number, a capital letter and a small letter
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="w-full">
                <span class="field-label"><ng-container i18n>Confirm password</ng-container><sup>*</sup></span>
                <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                  <input matInput [type]="confirmPasswordInputType" placeholder="Confirm password" formControlName="confirmPassword" data-test-id="sign-up-field-password" tabindex="4" />
                  <mat-icon class="cursor-pointer" matSuffix (click)="toggleVisibility(true)">{{ confirmPasswordVisible ? 'visibility' : 'visibility_off' }} </mat-icon>
                  <mat-error
                    class="text-[13px]"
                    *ngIf="signUpFormGroup.controls['confirmPassword'].hasError('mismatchedPasswords') && !signUpFormGroup.controls['confirmPassword'].hasError('required')"
                    i18n
                  >
                    Passwords are not same
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Checkbox for Terms of Service -->
              <div class="w-full">
                <mat-checkbox formControlName="agreement" class="text-sm"> </mat-checkbox>
                <span class="text-gray-600 inline-block w-[90%] align-text-top" i18n>
                  I agree to receive information on offerings from you and your partners. I can always withdraw this agreement
                </span>
                <mat-error *ngIf="signUpFormGroup.controls['agreement'].errors?.['required'] && signUpFormGroup.controls['agreement'].touched" i18n>
                  Please accept the terms of use and privacy policy to sign up
                </mat-error>
              </div>

              <div class="w-full">
                <mat-checkbox formControlName="termsOfService" class="text-sm"> </mat-checkbox>
                <span class="text-gray-600" i18n>
                  I accept the <span role="link" class="cursor-pointer underline text-black" (click)="openTermsOfServiceDialog()"> terms of use and privacy policy </span>
                </span>
                <mat-error *ngIf="signUpFormGroup.controls['termsOfService'].errors?.['required'] && signUpFormGroup.controls['termsOfService'].touched" i18n>
                  Please accept the terms of use and privacy policy to sign up
                </mat-error>
              </div>

              <!-- Sign Up Button -->
              <div class="mb-3 w-full">
                <div class="w-full flex flex-col place-content-between items-center">
                  <button mat-flat-button [disabled]="signUpFormGroup.invalid" class="flex-auto w-full button-primary" type="submit" data-test-id="btn-sign-up" i18n>Sign up</button>
                </div>
              </div>

              <!-- Sign up link -->
              <div class="sign-up-link flex flex-col justify-start items-center">
                <p>
                  <span class="sign-up-message text-gray-600" i18n>Already have an account?</span>
                  &nbsp;
                  <a (click)="redirectToSignIn()" class="underline cursor-pointer" i18n>Back to login</a>
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <div class="flex flex-col h-1/5 w-4/5 place-content-center">
      <div class="flex flex-col justify-end h-full mb-2">
        <!-- /Footer -->
      </div>
    </div>
  </div>
</div>
<div class="app-footer-container">
  <div class="flex flex-col justify-end h-full mb-2">
    <sp-footer></sp-footer>
  </div>
</div>
